export const resolveLink = path => {
  if (path === undefined) {
    return '/'
  }

  let newPath = path

  if (typeof path === 'object') {
    newPath = storyblokLink(path)
  }

  if (newPath.includes('https')) {
    return newPath.replace('#', '')
  }

  const leadingSlash = newPath.startsWith('/') ? '' : '/'

  const newUrl = `${leadingSlash}${newPath.replace(/\/$|$/, '/')}`

  return newUrl.replace('/#', '')
}

const storyblokLink = link => {
  return link.url || link.cached_url || ''
}

export default resolveLink
